import React from 'react';

import HomeworkForm from 'Components/HomeworkForm';

export default function HomeworkCreator() {
  return (
    <div>
      <HomeworkForm />
    </div>
  );
}
